//
const domainConfig = {
  demo: {
    country: "xx",
    lang: "en",
  },
  demo2: {
    country: "xx",
    lang: "en",
  },
  om: {
    country: "om",
    lang: window.location.hostname.includes("xr-discovery") ? "ar" : "en",
  },
  ca: {
    country: "ca",
    lang: "en",
  },
  de: {
    country: "de",
    lang: "de",
  },
  za: {
    country: "za",
    lang: "en",
  },
  ps: {
    country: "ps",
    lang: "ar",
  },
  sa: {
    country: "sa",
    lang: "ar",
  },
  cz: {
    country: "cz",
    lang: "cz",
  },
  qa: {
    country: "qa",
    lang: window.location.hostname.includes("xr-exposure") ? "ar" : "en",
  },
  nl: {
    country: "nl",
    lang: "nl",
  },
  co: {
    country: "co",
    lang: "es",
  },
  my: {
    country: "my",
    lang: "en",
  },
  rs: {
    country: "rs",
    lang: "rs",
  },
  th: {
    country: "th",
    lang: "th",
  },
  thtd: {
    country: "th",
    lang: "th",
  },
  es: {
    country: "es",
    lang: "es",
  },
  ee: {
    country: "ee",
    lang: "en",
  },
  id: {
    country: "id",
    lang: "in",
  },
  ae: {
    country: "ae",
    lang: "ar",
  },
  iq: {
    country: "iq",
    lang: "ar",
  },
  holozonia: {
    country: "xx",
    lang: "en",
  },
  kw: {
    country: "kw",
    lang: "ar",
  },
  pl: {
    country: "pl",
    lang: "pl",
  },
  se: {
    country: "se",
    lang: "se",
  },
  bh: {
    country: "bh",
    lang: "ar",
  },
  pk: {
    country: "pk",
    lang: "en",
  },
  gh: {
    country: "gh",
    lang: "en",
  },
  portal: {
    country: window.location.hostname.includes("hkxr-a") ? "hk" : "xx",
    lang: (() => {
      if (window.location.hostname.includes("hkxr-a")) {
        const urlParams = new URLSearchParams(window.location.search);
        const languageParam = urlParams.get("language");

        if (languageParam === "en") {
          return "en";
        } else if (languageParam === "zh") {
          return "zh-Hant-HK";
        } else {
          return "zh-Hant-HK";
        }
      }
      return "en";
    })(),
  },
  "id-tel": {
    country: "id",
    lang: "in",
  },
  fr: {
    country: "fr",
    lang: "fr",
  },
  ch: {
    country: "ch",
    lang: "de",
  },
  pe: {
    country: "pe",
    lang: "es",
  },
  umobile: {
    country: "my",
    lang: "en",
  },
  mx: {
    country: "mx",
    lang: "es",
  },
  sn: {
    country: "sn",
    lang: "fr",
  },
  dz: {
    country: "dz",
    lang: "fr",
  },
  app: {
    country: window.location.hostname.includes("aulaxr-mx") ? "mx" : "nl",
    lang: window.location.hostname.includes("aulaxr-mx") ? "es" : "es",
  },
  pt: {
    country: "pt",
    lang: "pt",
    unsubscribe_button: true,
  },
  ph: {
    country: "ph",
    lang: "en",
  },
  jp: {
    country: "jp",
    lang: "ja",
  },
  "ae-holozonia": {
    country: "ae",
    lang: "ar",
  },
  eg: {
    country: "eg",
    lang: "ar",
  },
  si: {
    country: "si",
    lang: "sl",
  },
};

const loginPrimeHash = [
  {
    domain: "om.xr-academy.com",
    hash: "GOaZPw",
  },
  {
    domain: "demo.xr-academy.com",
    hash: "joBeP1",
  },
  {
    domain: "holozonia.xr-academy.com",
    hash: "joBeP1",
  },
  {
    domain: "ca.mobiovr.com",
    hash: "bOWVyG",
  },
  {
    domain: "de.xr-academy.com",
    hash: "vOKby0",
  },
  {
    domain: "za.xr-academy.com",
    hash: "0PjKo7",
  },
  {
    domain: "ps.xr-academy.com",
    hash: "VPY0O7",
  },
  {
    domain: "sa.xr-academy.com",
    hash: "WolWP1",
  },
  {
    domain: "cz.xr-academy.com",
    hash: "LPxaoJ",
  },
  {
    domain: "qa.xr-academy.com",
    hash: "KOq6PQ",
  },
  {
    domain: "nl.xr-academy.com",
    hash: "dOp3y1",
  },
  {
    domain: "co.mobiovr.com",
    hash: "2oQnyp",
  },
  {
    domain: "my.xr-academy.com",
    hash: "GPkZOg",
  },
  {
    domain: "rs.xr-academy.com",
    hash: "GPevox",
  },
  {
    domain: "th.xr-academy.com",
    hash: "4P7JOE",
  },
  {
    domain: "es.xr-academy.com",
    hash: "BOmbPN",
  },
  {
    domain: "thtd.xr-academy.com",
    hash: "pPdNy5",
  },
  {
    domain: "ee.xr-academy.com",
    hash: "VyXBPW",
  },
  {
    domain: "id.xr-academy.com",
    hash: "jO8YP2",
  },
  {
    domain: "sa.mobiovr.com",
    hash: "5y4woq",
  },
  {
    domain: "ae.mobiovr.com",
    hash: "bO6bOM",
  },
  {
    domain: "iq.xr-academy.com",
    hash: "qy3xO1",
  },
  {
    domain: "kw.mobiovr.com",
    hash: "6OGYo9",
  },
  {
    domain: "pl.xr-academy.com",
    hash: "rOVWPg",
  },
  {
    domain: "se.xr-academy.com",
    hash: "eOARPb",
  },
  {
    domain: "bh.xr-academy.com",
    hash: "wywBor",
  },
  {
    domain: "ae.xr-academy.com",
    hash: "8P1qvP",
  },
  {
    domain: "kw.xr-academy.com",
    hash: "nyb77O",
  },
  {
    domain: "pk.xr-academy.com",
    hash: "woR1EP",
  },
  {
    domain: "id-tel.xr-academy.com",
    hash: "vOK2by",
  },
  {
    domain: "portal.xracademy.online",
    hash: "7OJpLo",
  },
  {
    domain: "portal.xr-academy.com",
    hash: "joB1eP",
  },
  {
    domain: "portal.xr-academy.online",
    hash: "EPrxy6",
  },
  {
    domain: "fr.xr-academy.com",
    hash: "bOWxVP",
  },
  {
    domain: "ch.xr-academy.com",
    hash: "VPYz0o",
  },
  {
    domain: "pe.xr-academy.com",
    hash: "LPxLaP",
  },
  {
    domain: "umobile.xr-academy.com",
    hash: "WolYWy",
  },
  {
    domain: "portal.xracademy.info",
    hash: "jyD7Qo",
  },
  {
    domain: "mx.xr-academy.com",
    hash: "joBeP1",
  },
  {
    domain: "portal.immersi-learn.com",
    hash: "4P7ZJO",
  },
  {
    domain: "portal.virtupaths.com",
    hash: "BOmrbP",
  },
  {
    domain: "portal.thenextgenxr.com",
    hash: "jO8JYo",
  },
  {
    domain: "portal.xrlab360.com",
    hash: "pPd8NP",
  },
  {
    domain: "sn.xr-lab.co",
    hash: "VyXYBO",
  },
  {
    domain: "ca.xr-academy.com",
    hash: "ROzwbP",
  },
  {
    domain: "dz.xr-zone.co",
    hash: "VoZGqy",
  },
  {
    domain: "app.xrstudios.nl",
    hash: "9yvwAO",
  },
  {
    domain: "rs.mobilnivr.com",
    hash: "bO6Qby",
  },
  {
    domain: "portal.hkxr-a.com",
    hash: "rOVRWO",
  },
  {
    domain: "ca.thevracademy.com",
    hash: "6OGKYO",
  },
  {
    domain: "bh.xr-experience.co",
    hash: "AON5gy",
  },
  {
    domain: "pt.academiavr.com",
    hash: "8onR3o",
  },
  {
    domain: "ch.vrxedge.com",
    hash: "0PLz7y",
  },
  {
    domain: "ph.siklabxr.com",
    hash: "eOAQRO",
  },
  {
    domain: "ae-holozonia.xr-academy.com",
    hash: "joBeP1",
  },
  {
    domain: "app.aulaxr-mx.com",
    hash: "EPrKxo",
  },
  {
    domain: "gh.afri-verse.com",
    hash: "8P1Bvo",
  },
  {
    domain: "om.xr-discovery.com",
    hash: "nybl7P",
  },
  {
    domain: "qa.xr-exposure.com",
    hash: "woRbEo",
  },
  {
    domain: "eg.xr-vision.com",
    hash: "vOKWbO",
  },
  {
    domain: "app.labacademy-bh.com",
    hash: "8OMKzo",
  },
  {
    domain: "ae.xr-edutainment.com",
    hash: "joBGey",
  },
  {
    domain: "th.xr-pulse.com",
    hash: "bOWJVy",
  },
  {
    domain: "si.xreduclass.com",
    hash: "8P1Beo",
  },
  {
    domain: "si.themelodymix.com",
    hash: "nyblAP",
  },
  {
    domain: "iq.xr-knowledge.com",
    hash: "mO29zy",
  },
  {
    domain: "kw.academic-lab.com",
    hash: "joBGJy",
  },
  {
    domain: "iq.xrmadrasa.com",
    hash: "eyE9ey",
  },
  {
    domain: "jp.kasougakuen.com",
    hash: "Wol7xP",
  },
];

// STRINGS USED HERE HAS TO BE IN LINE WITH THE DOMAIN OF WEBAPP(eg: www.mobiovr.com)
export const PRODUCT_XR_ACADEMY = "xr-academy";
export const PRODUCT_XRACADEMY = "xracademy";
export const PRODUCT_MOBIO_VR = "mobiovr";
export const PRODUCT_IMMERSI_LEARN = "immersi-learn";
export const PRODUCT_XRLAB360 = "xrlab360";
export const PRODUCT_THENEXTGEN = "thenextgenxr";
export const PRODUCT_VIRTUPATHS = "virtupaths";
export const PRODUCT_XR_LAB = "xr-lab";
export const PRODUCT_XR_ZONE = "xr-zone";
export const PRODUCT_XR_STUDIOS = "xrstudios";
export const PRODUCT_MOBILNIVR = "mobilnivr";
export const PRODUCT_THE_VR_ACADEMY = "thevracademy";
export const PRODUCT_XR_EXPERIENCE = "xr-experience";
export const PRODUCT_ACADEMIA_VR = "academiavr";
export const PRODUCT_HK_XR_A = "hkxr-a";
export const PRODUCT_VRXEDGE = "vrxedge";
export const PRODUCT_SIKLABXR = "siklabxr";
export const PRODUCT_AULAXR_MX = "aulaxr-mx";
export const PRODUCT_AFRI_VERSE = "afri-verse";
export const PRODUCT_XR_DISCOVERY = "xr-discovery";
export const PRODUCT_XR_EXPOSURE = "xr-exposure";
export const PRODUCT_XR_VISION = "xr-vision";
export const PRODUCT_LAB_ACADEMY = "labacademy-bh";
export const PRODUCT_XR_EDUTAINMENT = "xr-edutainment";
export const PRODUCT_XR_PULSE = "xr-pulse";
export const PRODUCT_XREDUCLASS = "xreduclass";
export const PRODUCT_THEMELODYMIX = "themelodymix";
export const PRODUCT_XR_KNOWLEDGE = "xr-knowledge";
export const PRODUCT_ACADEMIC_LAB = "academic-lab";
export const PRODUCT_XR_MADRASA = "xrmadrasa";
export const PRODUCT_KASOUGAKUEN = "kasougakuen";


export const COMPANY_SAM_MEDIA = "SAM_MEDIA";
export const COMPANY_TREND_TECH = "TREND_TECH";
export const STATC_PAGES = [
  "/terms-and-conditions",
  "/help-center",
  "/faq",
  "/refund-policy",
  "/privacy-policy",
];
export const restrictedSubDomains = ["fr", "cz", "se", "pl", "ch"];

export const HELP_CENTER_UTM_CAMPAIGN = "unsubscription-helpCenter";
export const MODAL_UTM_CAMPAIGN = "unsubscription-modal";

/* eslint-disable max-len */
export const modalStatusMsg = {
  success: `<strong>Congratulations!</strong> Your number has won a prize! Your Voucher Number. <strong>01234567689</strong> Your XR Academy OTT voucher can be redeemed online, for partner go to <a href="https://ottvoucher.com/frequently-asked-questions/" style="color:white;"> https://ottvoucher.com/frequently-asked-questions/</a>`,
  fail: "Sorry, your number did not win but not worry, next month we will give you a chance again.",
  error: "Something went wrong!",
};

export const domainThemes = {
  "immersi-learn": {
    primaryColor: "#02a90a",
    sceneInfoBgColor: "rgba(2, 169, 10, 0.895)",
    breadcrumbsColor: "#04ce0d",
    mainMenuBgImage: "/images/main-menu/bg-immersi.jpg",
    logo: "/images/intro/immersi-learn.png",
  },
  xrlab360: {
    primaryColor: "#eeb820",
    sceneInfoBgColor: "rgba(238,184,33, 0.895)",
    breadcrumbsColor: "#efc345",
    mainMenuBgImage: "/images/main-menu/bg-xrlab360.jpg",
    logo: "/images/intro/xrlab360.png",
  },
  thenextgenxr: {
    primaryColor: "#0c8ade",
    sceneInfoBgColor: "rgba(12,138 , 222, 0.895)",
    breadcrumbsColor: "#0099ff",
    mainMenuBgImage: "/images/main-menu/bg-thenextgen.jpg",
    logo: "/images/intro/thenextgenxr.png",
  },
  virtupaths: {
    primaryColor: "#673AB7",
    sceneInfoBgColor: "rgba(103, 58, 183, 0.895)",
    breadcrumbsColor: "#8959e0",
    mainMenuBgImage: "/images/main-menu/bg-virtupaths.jpg",
    logo: " /images/intro/virtupaths.png",
  },
  mobiovr: {
    logo: "/images/header/mobiovrlogo.png",
  },
  "xr-lab": {
    logo: "/images/intro/xr-lab.svg",
  },
  "xr-zone": {
    logo: "/images/intro/xr-zone_logo.svg",
  },
  xrstudios: {
    logo: "/images/intro/xr_studios_logo.svg",
  },
  mobilnivr: {
    logo: "/images/intro/MobilniVR_Logo.svg",
  },
  thevracademy: {
    logo: "/images/intro/TheVRAcademy_Logo.svg",
    mainMenuBgImage: "/images/main-menu/bg-virtupaths.jpg",
  },
  "xr-experience": {
    logo: "/images/intro/xrexpereince_logo.svg",
  },
  academiavr: {
    logo: "/images/intro/academiaVR_logo.svg",
    unsubscribe_button: true,
    pt: {
      vrButtonExtraLeftSpace: true,
    },
  },
  vrxedge: {
    logo: "/images/intro/vrxedge_logo.svg",
  },
  "hkxr-a": {
    logo: "/images/intro/xr-a_logo.png",
    // preLogoImg:'/images/header/csl_logo.png',
    // postLogoImg:"/images/header/AI.png"
  },
  siklabxr: {
    logo: "/images/intro/siklabxr_logo.svg",
  },
  "aulaxr-mx": {
    logo: "/images/intro/aulaxr_logo.svg",
  },
  "afri-verse": {
    logo: "/images/intro/afriverse_logo.svg",
  },
  "xr-discovery": {
    logo: "/images/intro/xr_discovery-logo.svg",
  },
  "xr-exposure": {
    logo: "/images/intro/xr-exposure_logo.svg",
  },
  "labacademy-bh": {
    logo: "/images/intro/lab-academy-logo.svg",
  },
  "xr-vision": {
    logo: "/images/intro/xr_vision_logo.svg",
  },
  "xr-edutainment": {
    logo: "/images/intro/xr-edutainment_logo.svg",
  },
  "xr-pulse": {
    logo: "/images/intro/xr_pulse_logo.svg",
  },
  xreduclass: {
    logo: "/images/intro/xreduclass_logo.svg",
  },
  themelodymix: {
    logo: "/images/intro/themelodymix_logo.svg",
  },
  "xr-knowledge": {
    logo: "/images/intro/xr-knowledge_logo.svg",
  },
  "xr-academy": {
    logo: "/images/header/logo.svg",
    my: {
      whatsappUrl:
        "https://cdn.smooch.io/message-us/index.html?channel=whatsapp&color=green&size=standard&radius=4px&label=Let’s chat&number=15559118221",
    },
    th: {
      zendeskLineAccountURL: "https://lin.ee/PArWEr5",
      whatsappUrl:
        "https://static.zdassets.com/message-us/meta/index.html?channel=whatsapp&color=green&size=standard&radius=4px&label=Let’s chat&number=15558651365",
    },
    sg: {
      whatsappUrl:
        "https://static.zdassets.com/message-us/meta/index.html?channel=whatsapp&color=green&size=standard&radius=4px&label=Let’s chat&number=15558651365",
    },
    hk: {
      whatsappUrl:
        "https://static.zdassets.com/message-us/meta/index.html?channel=whatsapp&color=green&size=standard&radius=4px&label=Let’s chat&number=15558651365",
    },
    pe: {
      appShortcutsDock: true,
    },
  },
  "academic-lab": {
    logo: "/images/intro/academic-lab_logo.svg",
  },
  xrmadrasa: {
    logo: "/images/intro/xr-madrasa-logo.svg",
    introLogo: "/images/intro/xr-madrasa-logo.svg",
    favicon: "/xr-madrasa-favicon.svg",
    pageTitle: "XR Madrasa",
  },
  kasougakuen: {
    logo: "/images/intro/kasougakuen_logo.svg",
    introLogo: "/images/intro/kasougakuen_logo.svg",
    favicon: "/kasougakuen-favicon.png",
    pageTitle: "Kasougakuen",
  },
};

export const domainCompanyInfo = {
  sam_media_company_info: {
    content:
      "Sam Media BV info Van Diemenstraat 356, 1013 CR Amsterdam, The Netherlands",
    link: "sam-media.com",
  },
  mobimilia_company_info: {
    content:
      "Mobimilia Van Diemenstraat 356, 1013 CR Amsterdam, The Netherlands",
    link: "www.mobimilia.com",
  },
  pepperose_company_info: {
    content:
      "Pepperose Limited - The Maylands Building, Office 42, Maylands Avenue Hemel Hempstead, England, HP2 7TG",
    link: "www.pepperoseltd.com",
  },
};
export const SAM_MEDIA_INFO_DOMAINS = ["portal.xracademy.online"];
export const MOBIMILIA_INFO_DOMAINS = [
  "portal.xracademy.info",
  "portal.thenextgenxr.com",
  // "localhost",
];
export const PEPPEROSE_INFO_DOMAINS = [
  "portal.xrlab360.com",
  "portal.immersi-learn.com",
  "portal.virtupaths.com",
];
export const productNameMap = {
  [PRODUCT_XR_ACADEMY]: PRODUCT_XR_ACADEMY,
  [PRODUCT_XRACADEMY]: PRODUCT_XRACADEMY,
  [PRODUCT_MOBIO_VR]: PRODUCT_MOBIO_VR,
  [PRODUCT_IMMERSI_LEARN]: PRODUCT_IMMERSI_LEARN,
  [PRODUCT_XRLAB360]: PRODUCT_XRLAB360,
  [PRODUCT_THENEXTGEN]: PRODUCT_THENEXTGEN,
  [PRODUCT_VIRTUPATHS]: PRODUCT_VIRTUPATHS,
  [PRODUCT_XR_LAB]: PRODUCT_XR_LAB,
  [PRODUCT_XR_ZONE]: PRODUCT_XR_ZONE,
  [PRODUCT_XR_STUDIOS]: PRODUCT_XR_STUDIOS,
  [PRODUCT_MOBILNIVR]: PRODUCT_MOBILNIVR,
  [PRODUCT_XR_EXPERIENCE]: PRODUCT_XR_EXPERIENCE,
  [PRODUCT_THE_VR_ACADEMY]: PRODUCT_THE_VR_ACADEMY,
  [PRODUCT_ACADEMIA_VR]: PRODUCT_ACADEMIA_VR,
  [PRODUCT_HK_XR_A]: PRODUCT_HK_XR_A,
  [PRODUCT_VRXEDGE]: PRODUCT_VRXEDGE,
  [PRODUCT_SIKLABXR]: PRODUCT_SIKLABXR,
  [PRODUCT_AULAXR_MX]: PRODUCT_AULAXR_MX,
  [PRODUCT_AFRI_VERSE]: PRODUCT_AFRI_VERSE,
  [PRODUCT_XR_DISCOVERY]: PRODUCT_XR_DISCOVERY,
  [PRODUCT_XR_EXPOSURE]: PRODUCT_XR_EXPOSURE,
  [PRODUCT_XR_VISION]: PRODUCT_XR_VISION,
  [PRODUCT_LAB_ACADEMY]: PRODUCT_LAB_ACADEMY,
  [PRODUCT_XR_EDUTAINMENT]: PRODUCT_XR_EDUTAINMENT,
  [PRODUCT_XR_PULSE]: PRODUCT_XR_PULSE,
  [PRODUCT_XREDUCLASS]: PRODUCT_XREDUCLASS,
  [PRODUCT_THEMELODYMIX]: PRODUCT_THEMELODYMIX,
  [PRODUCT_XR_KNOWLEDGE]: PRODUCT_XR_KNOWLEDGE,
  [PRODUCT_ACADEMIC_LAB]: PRODUCT_ACADEMIC_LAB,
  [PRODUCT_XR_MADRASA]: PRODUCT_XR_MADRASA,
  [PRODUCT_KASOUGAKUEN]: PRODUCT_KASOUGAKUEN,

};
export const changeLogoHeightDomains = [
  "immersi-learn",
  "xrlab360",
  "thenextgenxr",
  "virtupaths",
  "xr-lab",
  "xrstudios",
  "mobilnivr",
  "thevracademy",
  "xr-experience",
  "academiavr",
  "vrxedge",
  "hkxr-a",
  "siklabxr",
  "xr-pulse",
  "xrmadrasa",
  "kasougakuen",

];
export { domainConfig, loginPrimeHash };
